<template>
    <div class="slide-one" v-loading="loading">
        <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{$t('h.BGT')   }}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('h.ABE')  }}</span>
                </div>
                <div class="swiper-slide-one-image">
                    <img src="../assets/img/1.jpg" alt="" style="margin-right:50px;height:22rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/2.jpg" alt="" style="height:22rem;box-shadow: -10px -10px  rgb(217,217,217);">
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{$t('h.MS')}}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('h.AGENT')}}</span>
                </div>
                <div class="swiper-slide-one-image">
                    <img src="../assets/img/3.jpg" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/4.jpg" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/5.png" alt="" style="height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{$t('h.SHM')}}</span>
                </div>
                <div class="swiper-slide-two-image">
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/6.png">
                        <p>观澜湖</p>
                    </div>

                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/7.png">
                        <p>沙 河</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/8.png">
                        <p>西 丽</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/9.png">
                        <p>佘 山</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/10.png">
                        <p>天 马</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/11.png">
                        <p>鸿 华</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/12.png">
                        <p>华 彬</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/13.png">
                        <p>九龙湖</p>
                    </div>
                    <div class="swiper-slide-two-content">
                        <img src="../assets/img/14.png" alt="">
                        <p>风 神</p>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{$t('h.EO')}}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('h.HOLCEA')}}</span>
                </div>
                <div class="swiper-slide-one-image">
                    <img src="../assets/img/15.jpg" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);border:1px solid #999;">
                    <img src="../assets/img/16.jpg" style="height:23rem;box-shadow: -10px -10px  rgb(217,217,217);border:1px solid #999;">
                </div>
            </swiper-slide>
           
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{$t('h.TGPS')}}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('h.SIC')}}</span>
                </div>
                <div class="swiper-slide-one-image">
                    <img src="../assets/img/18.jpg" alt="" style="margin-right:50px;height:22rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/19.jpg" alt="" style="height:22rem;box-shadow: -10px -10px  rgb(217,217,217);">
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-slide">
                <div class="swiper-slide-one">
                    <span>{{ $t('h.NM') }}</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('h.MCALSR') }}</span>
                </div>
                <div class="swiper-slide-one-image">
                    <img src="../assets/img/26.png" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/27.png" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/28.png" alt="" style="margin-right:50px;height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                    <img src="../assets/img/29.png" alt="" style="height:23rem;box-shadow: -10px -10px  rgb(217,217,217);">
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="pagination"></div>

    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    name: "HelloWorld",
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            height: window.innerHeight - 115,
            loading: true,
            caseList: [],
            newsList: [],
            swiperOption: {
                pagination: {
                    el: ".swiper-pagination",
                },
                autoplay: true,
                // 播放的速度
                speed: 1000,
            },
        };
    },
    created() {},
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted() {
        this.loading = false;
    },
};
</script>

<style  scoped>
.swiper-slide {
    width: 100%;
    overflow: hidden;
    font-size: 2rem;
    text-align: center;
    display: flex;
    min-width: 1120px;
    flex-direction: column;
}
.swiper-slide .swiper-slide-one {
    padding-top: 2rem;
    margin-top: 1rem;
}
.swiper-slide .swiper-slide-one-image {
    margin-top: 2.5rem;
}
.swiper-slide .swiper-slide-two-image {
    text-align: center;
    display: flex;
    margin: 0 auto;
    margin-top: 5rem;
    font-size: 1.5rem;
}
.swiper-slide .swiper-slide-two-image .swiper-slide-two-content {
    padding: 1.5rem;
    margin-top: 2.5rem;
}
.swiper-slide .swiper-slide-two-image .swiper-slide-two-content img {
    height: 88px;
}
.swiper-slide .swiper-slide-two-image .swiper-slide-two-content p {
    margin-top: 1.5rem;
}

.slide-one .swiper-pagination {
    width: 100%;
}
#pagination /deep/ .swiper-pagination-bullet {
    width: 10px !important;
    height: 10px !important;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    margin-left: 8px;
    margin-top: 30px;
}
#pagination /deep/ .swiper-pagination-bullet-active {
    background: #000;
}
</style>